export default __webpack_public_path__ + "static/Exo2-Medium-1144815de44512d8c322671f79e176cb.ttf";